import { useStore } from "../../stores/StoreContext";
import { ChatService } from "../LogicServices/ChatService";

export function useChatService(): ChatService {
  const storeContext = useStore();
  return new ChatService(storeContext);
}
